var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button } from "../Button";
import Caption from "../Caption";
import Card from "../Card";
import Heading from "../Heading";
import Markdown from "../Markdown";
import React from 'react';
import { layout } from 'styled-system';
import { css, styled } from "../../utils";
var StyledCard = styled(Card)(function (_a) {
    var withAvatar = _a.withAvatar, colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n    position: relative;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n\n    && {\n      ", ";\n      ", ";\n    }\n\n    img {\n      position: absolute;\n      top: -50px;\n    }\n\n    button {\n      margin-top: 1rem;\n    }\n  "], ["\n    background-color: ", ";\n    position: relative;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n\n    && {\n      ", ";\n      ", ";\n    }\n\n    img {\n      position: absolute;\n      top: -50px;\n    }\n\n    button {\n      margin-top: 1rem;\n    }\n  "])), colors.gray4, withAvatar && 'padding-top: 7rem', withAvatar && 'margin-top: 4.5rem');
}, layout);
var StyledMarkdown = styled(Markdown)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  p {\n    margin: 1rem 0;\n    text-align: center;\n  }\n"], ["\n  p {\n    margin: 1rem 0;\n    text-align: center;\n  }\n"])));
var CardBanner = function (_a) {
    var title = _a.title, content = _a.content, buttonLabel = _a.buttonLabel, onClick = _a.onClick, avatarSrc = _a.avatarSrc, avatarCaption = _a.avatarCaption, className = _a.className, layoutProps = __rest(_a, ["title", "content", "buttonLabel", "onClick", "avatarSrc", "avatarCaption", "className"]);
    return (React.createElement(StyledCard, __assign({ "data-component": "CardBanner", className: className, withAvatar: !!avatarSrc }, layoutProps),
        avatarSrc && React.createElement("img", { src: avatarSrc, alt: "avatar" }),
        avatarSrc && avatarCaption && React.createElement(Caption, { light: true }, avatarCaption),
        React.createElement(Heading.Heading2, { textAlign: "center" }, title),
        React.createElement(StyledMarkdown, { source: content }),
        React.createElement(Button, { outline: true, onClick: onClick, "data-intent": "callback" }, buttonLabel)));
};
export default CardBanner;
var templateObject_1, templateObject_2;
//# sourceMappingURL=CardBanner.js.map